import diffPieveWorkflowSteps from '@shared/pieve/diffPieveWorkflowSteps.js';
import hydrateWorkflowStepApps from '@/redux/selectors/pieveSelectors/lib/hydrateWorkflowStepApps.js';

// What changed between two snapshots, compared on their stored steps — app icons are a client lookup, not part of a
// step — and then drawn with their apps for the lists that show them. `null` until both snapshots have loaded, which
// means their definitions: the catalog list files the draft row without one, so the row exists before the draft read
// lands (or when it fails).
const diffWorkflowSnapshotSteps = ({ before, after, appsMetadataItems }) => {
  if (!before?.definition || !after?.definition) {
    return null;
  }

  const { added, changed, removed } = diffPieveWorkflowSteps({ before: before.definition.steps, after: after.definition.steps });
  const appMetadataById = { ...before.appMetadataById, ...after.appMetadataById };
  const hydrate = (steps) => hydrateWorkflowStepApps({ steps, appsMetadataItems, appMetadataById });
  const changedSteps = hydrate(changed.map((change) => change.step));

  return {
    added: hydrate(added),
    changed: changed.map((change, index) => ({ ...change, step: changedSteps[index] })),
    removed: hydrate(removed),
    count: added.length + changed.length + removed.length
  };
};

export default diffWorkflowSnapshotSteps;
